var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3803 25.8333C5.22439 25.8333 2.66602 23.3051 2.66602 20.1863C2.66602 17.0675 5.22439 14.5392 8.3803 14.5392C8.75913 14.5392 9.12935 14.5756 9.48756 14.6452M19.174 11.2029C19.9683 10.9255 20.8231 10.7745 21.7136 10.7745C22.5865 10.7745 23.4251 10.9196 24.2061 11.1866M9.48756 14.6452C9.1821 13.8304 9.01522 12.9492 9.01522 12.0294C9.01522 7.87103 12.4264 4.5 16.6343 4.5C20.5539 4.5 23.7822 7.42495 24.2061 11.1866M9.48756 14.6452C10.2401 14.7912 10.9397 15.0832 11.5549 15.4901M24.2061 11.1866C27.19 12.207 29.3327 15.0082 29.3327 18.3039C29.3327 21.9133 26.7628 24.9294 23.3327 25.663",
    stroke: "#666D80",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0007 21.8335V29.8335M16.0007 21.8335L18.6673 24.5002M16.0007 21.8335L13.334 24.5002",
    stroke: "#666D80",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon1);
export default __webpack_public_path__ + "static/media/upload-icon1.10cdb1f2b40d60a3d7f060c92336e527.svg";
export { ForwardRef as ReactComponent };